import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";
import {numberWithComma} from "../../../../utils/formatters/Numbers";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";

const EditPositionView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-7">
                        <TitlePage title="Prestatario \ Captura de Garantías \ Editar Posición"/>
                    </div>
                    <div className="p-col-5" align="right">
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnCaptureGuaranteesPage}/>&nbsp;
                        <Button label="Guardar" onClick={props.editPosition}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Cuenta" isBold={true}/>
                        <SubtitleLabel header={props.positionData.cuenta}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Emisora" isBold={true}/>
                        <SubtitleLabel header={props.positionData.emisora}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-4">
                        <SubtitleLabel header="Tipo Valor" isBold={true}/>
                        <SubtitleLabel header={props.positionData.tipoValor}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Posición Total" isBold={true}/>
                        <NumberFormat thousandSeparator={true}
                                      allowNegative={false}
                                      maxLength={17}
                                      required={true}
                                      decimalScale={0}
                                      fixedDecimalScale={false}
                                      name="posicion"
                                      placeholder="Ex: 9,999.00"
                                      customInput={InputText}
                                      onChange={props.onChangeInputText}
                                      value={Number(props.positionData.posicion)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Total a Garantizar" isBold={true}/>
                        <NumberFormat thousandSeparator={true}
                                      allowNegative={false}
                                      maxLength={17}
                                      required={true}
                                      decimalScale={0}
                                      fixedDecimalScale={false}
                                      name="disponibleGarantia"
                                      placeholder="Ex: 9,999.00"
                                      customInput={InputText}
                                      onChange={props.onChangeInputText}
                                      value={Number(props.positionData.disponibleGarantia)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Total a Prestar" isBold={true}/>
                        <SubtitleLabel header={numberWithComma(props.positionData.disponible,
                            "left", true)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Títulos en Garantía" isBold={true}/>
                        <SubtitleLabel header={numberWithComma(props.positionData.garantiasVigentes,
                            "left", true)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Títulos en Préstamos" isBold={true}/>
                        <SubtitleLabel header={numberWithComma(props.positionData.prestamoVigente,
                            "left", true)}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Disponible para Garantizar" isBold={true}/>
                        <Typography variant="subtitle2" gutterBottom
                                    style={props.positionData.guaranteeAvailable < 0 ? {color: "red"} : {}}>
                            {numberWithComma(props.positionData.guaranteeAvailable,
                                "left", true)}
                        </Typography>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <SubtitleLabel header="Posición disponible" isBold={true}/>
                        <Typography variant="subtitle2" gutterBottom
                                    style={props.positionData.availablePosition < 0 ? {color: "red"} : {}}>
                            {numberWithComma(props.positionData.availablePosition,
                                "left", true)}
                        </Typography>
                    </div>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(EditPositionView);